module.exports = __webpack_public_path__ + "img/annotated_drone_flying.1b3a5387.png";